module.exports = __webpack_public_path__ + "img/tips-not-covered.f886ab77.svg";